import type { BracketGroup, BracketRound, BracketSlot } from '@shared-types/bracket.types';

export const generateBracketKey = (bracket: BracketRound[]): string => {
  if (!bracket.length) return 'empty-bracket';

  const getTeamIds = (slot: BracketSlot): string[] => {
    const teams = Array.isArray(slot.teams) ? slot.teams : [slot.teams];
    return teams.map((team) => team.teamId);
  };

  const formatGroup = (group: BracketGroup): string => {
    const teamIds = Array.isArray(group.slots) ? group.slots.flatMap(getTeamIds).join('-') : '';
    return `${group.groupId}:${teamIds}`;
  };

  const formatRound = (round: BracketRound): string => {
    const groupKeys = round.groups.map(formatGroup).join('|');
    return `${round.roundId}:${groupKeys}`;
  };

  return bracket.map(formatRound).join(';');
};
